import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';

export const SvgTransferInOutDimension = {
  height: 20,
  width: 20,
  viewBox: '0 0 16 16',
};

export const SvgTransferInOut = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <path fill="currentColor" d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0" />
      <path
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.333}
        d="M4.8 7.533h-.167v.933h5.025l-2.196 2.196-.118.118.118.118.42.42.118.117.118-.117 3.2-3.2.118-.118-.118-.118-3.2-3.2L8 4.564l-.118.118-.42.42-.118.118.118.118 2.196 2.195z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
));
